export default __webpack_public_path__ + "56957bab666fdb31b95d6c11403ec725.svg";